<script setup lang="ts">
import {useI18n} from 'vue-i18n'

const {t} = useI18n()
</script>

<template>
  <div class="flex min-h-screen flex-col no-scrollbar bg-gray-50">
    <a
      href="#main-content"
      class="skip-link sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
    >
      {{ t('accessibility.skip_to_content') }}
    </a>
    <main id="main-content" class="grow" role="main" tabindex="-1">
      <RouterView />
    </main>
  </div>
</template>
